import type { Currency } from '@optionway/models';
import { CurrencyEnum } from '@optionway/models';

interface CurrencyStore {
  currency: Currency;
}

export const useCurrencyStore = defineStore('currency', {
  state: (): CurrencyStore => ({
    // Serializable value only. Persistence lives client-side in currency-selector.vue (mounted in
    // the header, rendered once the partner allows a second currency) — a storage composable
    // created in state() never runs again on the client once the store travelled in the SSR
    // payload (pinia only calls state() when the payload has no entry for the store).
    currency: CurrencyEnum.EUR,
  }),
  getters: {
    currencyList: () => {
      return Object.values(CurrencyEnum) as Currency[];
    },
    isEuro(): boolean {
      return this.currency === 'EUR';
    },
  },
  actions: {
    changeCurrency(current: Currency) {
      if (this.currencyList.includes(current)) {
        this.currency = current;
      }
    },
  },
});
